import * as React from "react";

const ElectronicsIcon: React.FC = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="161px"
            height="136px"
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 720 720"
        >
            <g fill="#53565a">
                <path d="M630.59,496.31l-535.31.07a10.93,10.93,0,0,1-10.94-10.93l0-393.27A10.93,10.93,0,0,1,95.22,81.25l535.32-.07a10.93,10.93,0,0,1,10.93,10.93l0,393.27A10.93,10.93,0,0,1,630.59,496.31Zm-524.38-21.8,513.44-.07,0-371.39-513.45.07Z" />
                <path d="M699.16,638.26l-672.42.09a10.93,10.93,0,0,1-9.84-15.69l68.53-142a10.93,10.93,0,0,1,9.84-6.19l535.32-.07a10.92,10.92,0,0,1,9.84,6.18l68.57,142a10.93,10.93,0,0,1-9.84,15.69Zm-655-21.78,637.58-.08-58-120.09-521.59.07Z" />
                <path d="M154,528.76H135.86a5.47,5.47,0,1,1,0-10.93H154a5.47,5.47,0,1,1,0,10.93Z" />
                <path d="M226.63,528.75H208.54a5.47,5.47,0,0,1,0-10.93h18.1a5.47,5.47,0,0,1,0,10.93Z" />
                <path d="M299.31,528.74h-18.1a5.47,5.47,0,0,1,0-10.93h18.1a5.47,5.47,0,0,1,0,10.93Z" />
                <path d="M372,528.73H353.89a5.47,5.47,0,1,1,0-10.93H372a5.47,5.47,0,1,1,0,10.93Z" />
                <path d="M444.66,528.72H426.57a5.47,5.47,0,1,1,0-10.93h18.09a5.47,5.47,0,1,1,0,10.93Z" />
                <path d="M517.34,528.71H499.25a5.47,5.47,0,1,1,0-10.93h18.09a5.47,5.47,0,1,1,0,10.93Z" />
                <path d="M590,528.7H571.93a5.47,5.47,0,0,1,0-10.94H590a5.47,5.47,0,0,1,0,10.93Z" />
                <path d="M134.28,563H114.49a5.47,5.47,0,0,1,0-10.94h19.79a5.47,5.47,0,1,1,0,10.93Z" />
                <path d="M213.8,563H194a5.47,5.47,0,0,1,0-10.94H213.8a5.47,5.47,0,1,1,0,10.93Z" />
                <path d="M293.32,563H273.53a5.47,5.47,0,0,1,0-10.94h19.8a5.47,5.47,0,1,1,0,10.93Z" />
                <path d="M372.84,563H353.05a5.47,5.47,0,0,1,0-10.94h19.8a5.47,5.47,0,1,1,0,10.93Z" />
                <path d="M452.36,563h-19.8a5.47,5.47,0,0,1,0-10.93h19.8a5.47,5.47,0,1,1,0,10.93Z" />
                <path d="M531.88,563h-19.8a5.47,5.47,0,0,1,0-10.93h19.8a5.47,5.47,0,0,1,0,10.93Z" />
                <path d="M611.4,563H591.6a5.47,5.47,0,1,1,0-10.93h19.8a5.47,5.47,0,0,1,0,10.93Z" />
                <path d="M123,597.29H102.22a5.47,5.47,0,0,1,0-10.93H123a5.47,5.47,0,0,1,0,10.93Z" />
                <path d="M373.33,597.26l-187.66,0a5.47,5.47,0,1,1,0-10.93l187.66,0a5.47,5.47,0,1,1,0,10.94Z" />
                <path d="M456.78,597.25H436a5.47,5.47,0,1,1,0-10.94h20.77a5.47,5.47,0,0,1,0,10.94Z" />
                <path d="M540.23,597.23H519.45a5.47,5.47,0,0,1,0-10.94h20.77a5.47,5.47,0,1,1,0,10.93Z" />
                <path d="M623.67,597.22H602.9a5.47,5.47,0,1,1,0-10.94h20.77a5.47,5.47,0,1,1,0,10.93Z" />
            </g>
            <path
                d="M587.2,447.47l-448.55.06a5.48,5.48,0,0,1-5.47-5.47l0-306.5a5.47,5.47,0,0,1,5.47-5.47L587.16,130a5.47,5.47,0,0,1,5.47,5.47l0,306.5A5.47,5.47,0,0,1,587.2,447.47ZM144.12,436.6l437.62-.06,0-295.58L144.08,141Z"
                fill="#e1523d"
            />
        </svg>
    );
};

export default React.memo(ElectronicsIcon);
